import styled from 'styled-components';

import { gray1, gray7 } from './Const';

export const TemplateHeroOffset = styled.div`
    z-index: 0;
    padding-top: 0;

    @media (min-width: 992px) {
        padding-top: 30px;
    }
`;

export const TemplateHero = styled.div`
    overflow: auto;
    background-color: white;
    box-shadow: 0 1px 3px 0 fade(${gray1}, 30%);
    border-radius: 0 0 3px 3px;
    position: relative;

    @media (min-width: 1200px) {
        box-shadow: 0 6px 18px 0 fade(${gray1}, 30%);
        border-radius: 0
    }
`;

export const TemplateDetail = styled.div`
  padding: 18px;

  @media (min-width: 992px) {
     padding: 30px;
  }
`;

export const DescriptionBottom = styled.p`
    margin-bottom: 18px;

    @media (min-width: 768px) {
        margin-bottom: 24px;
    }

    @media (min-width: 992px) {
        margin-bottom: 42px;
    }
`;

export const PreziBG = styled.div`
    z-index: -1;
    position: fixed;
    left: -30px;
    top: -30px;
    height: 110vh;
    width: 110vw;
    filter: blur(10px);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    @media (min-width: 768px) {
       height: 566px;
    }

    @media (min-width: 992px) {
       height: 730px;
    }

    @media (min-width: 1200px) {
       height: 420px;
    }
`;

export const TemplatePreviewVideoOnlyImg = styled.img`
    overflow: hidden;
`;

export const TemplatePreviewVideoOnlyVideo = styled.video`
    overflow: hidden;
`;

export const EdgeMask = styled.div`
    z-index: -1;
    position: absolute;
    top: 242px;
    height: 380px;
    width: 100%;
    background-color: ${gray7};

    @media (min-width: 768px) {
        top: 453px;
    }

    @media (min-width: 992px) {
        top: 607px;
    }

    @media (min-width: 1200px) {
        top: 300px;
        height: 220px;
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/TemplateHeader.ts